import { render } from "./Dots.svg?vue&type=template&id=bef46af2"
const script = {}
script.render = render

export default script